// extracted by mini-css-extract-plugin
export default {"listTags":"list_listTags__8w0ag","header":"list_header__5dwxC","tags":"list_tags__mdspK","tag":"list_tag__HRtqY","rotate":"list_rotate__qklBd"};